<template>
<div>
    <c-row>
        <c-col span="12">
            <c-form @submit.prevent="validateBeforeSubmit">
                <c-form-switch label="Allow documents to be uploaded via email" v-model="settings.allow_email_input" />
                <c-row><span class='u-mt-10'></span></c-row>
                <c-row>
                    <c-col offset=2>
                        <c-form-field label="Send emails to:" help="This is the email address that Doqument uses to receive documents from you.">
                            <c-form-input v-model="settings.dedicated_address" readonly :disabled="!settings.allow_email_input"></c-form-input>
                        </c-form-field>
                        <c-form-field label="Whitelisted senders:" help="Enter here all addresses that are allowed to send documents via emails, sepparated by commas. Addresses not listed here will be ignored. Specify multiple sends from a sigle domain by enclosing the names in accolades, e.g. {john,mary}@sender.com.">
                            <c-form-input v-model="settings.white_list" name='white_list' :disabled="!settings.allow_email_input" v-validate="'required'"></c-form-input>
                        <span class="u-fs-12 u-color-danger" v-show="errors.has('white_list')">Please specify the white listed senders</span>
                        </c-form-field>
                        <c-divider placement="end"><span  class="u-color-success u-ml-5">CONFIRMATION OF RECEIPT</span></c-divider>
                        <c-form-field label="Send confirmation of receipt to:" help="Specify a list of addresses where to send a confirmation that an email was received and documents will be processed. Usefull especially when document results are not delivered by email but are processed automatically via API.">
                            <c-form-input v-model="settings.send_receipt_to" :disabled="!settings.allow_email_input"></c-form-input>
                        </c-form-field>
                        <c-form-field help="Send confirmation of receipt as reply to the original email, filtered using the list of domains below">
                            <c-form-checkbox v-model="settings.send_receipt_as_reply" label="Reply with confirmation of receipt" :disabled="!settings.allow_email_input" />
                        </c-form-field>
                        <c-divider placement="end"><span  class="u-color-success u-ml-5">RESULTS</span></c-divider>
                        <c-form-field label="Send results to:" help="Specify a list of addresses where to send the processing results to. Same formatting as described above can be used.">
                            <c-form-input v-model="settings.send_results_to" :disabled="!settings.allow_email_input"></c-form-input>
                        </c-form-field>
                        <c-form-field help="Send results as reply to the original email, filtered using the list of domains below">
                            <c-form-checkbox v-model="settings.send_results_as_reply" label="Reply with results" :disabled="!settings.allow_email_input" />
                        </c-form-field>
                        <c-form-field label="Restrict reply messages to the following domains:" help="Reply messages will only be sent to recipients from the domains listed here. Usefull to restrict such messages to people from your organization(s).">
                            <c-form-input v-model="settings.reply_filter_domains" :disabled="!settings.allow_email_input"></c-form-input>
                        </c-form-field>
                        <c-form-field help="By default, documents with results delivered by email are marked as read so they are not confused with those uploaded in the portal. This setting allows such results to be kept unread so they can be seen by automatic import tools via API.">
                            <c-form-checkbox v-model="settings.keep_results_unread" label="Keep results unread" :disabled="!settings.allow_email_input" />
                        </c-form-field>
                        <c-form-field v-if="false" label="Send technical issues to:" help="Specify a list of addresses where to send a emails in case documents cannot be parsed or other issue occurs.">
                            <c-form-input v-model="settings.notify_unrecognized" :disabled="!settings.allow_email_input"></c-form-input>
                        </c-form-field>
                    </c-col>
                </c-row>
            </c-form>
        </c-col>
        <c-col>
        <nav class="navbar">
          <div class="navbar__start">
          </div>
          <div class="navbar__end">
            <a class="navbar__item" v-tooltip="'Write Changes'" @click="onConfirm"><i class="icon-floppy-disk u-h4 u-color-success"></i><span class="u-color-success u-ml-5">SAVE CHANGES</span></a>
          </div>
        </nav>
        </c-col>
    </c-row>
</div>

</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  name: 'ClientEmailInput',
  data () {
    return {
      userName: '',
      client: '',
      settings: {
        allow_email_input: false,
        client: 'client',
        dedicated_address: 'client@doqument.ro',
        keep_results_unread: false,
        notify_unrecognized: null,
        send_receipt_cc: null,
        send_receipt_to: null,
        send_results_cc: null,
        send_results_to: null,
        white_list: null
      }
    }
  },

  computed: {
    ...mapState('auth', ['clientCode'])
  },

  mounted () {
    this.fetchSettings()
  },

  methods: {
    fetchSettings () {
      let url = process.env.API + this.clientCode + '/email-input'

      axios.get(url).then((response) => {
        this.settings = response.data
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
        this.$snotify.error(
          'Error retrieving data',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          }
        )
      }
      )
    },

    onConfirm () {
      this.validateBeforeSubmit()
    },

    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
                this.savePreferences()
        }
      })
    },
    savePreferences () {
      let url = process.env.API + this.clientCode + '/email-input'

      axios.put(url, this.settings).then((response) => {
        console.log(response.data)
        this.$snotify.success(
          'Changes saved successfully',
          null,
          {
            position: 'centerTop',
            timeout: 3000,
            showProgressBar: false
          }
        )
      }).catch((reason) => {
        console.error('Could not change password')
        this.globalError = 'Unable to change password (old password does not match?)'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ClientSettings/EmailInput.vue